import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientHeadSaveAddressesMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { AddressesWithFilesParam } from 'api/types/params/onboarding/addressesParam';
import { isFinanceProject, isGlobalProject } from 'config';

import { parseLegalClientHeadEntity } from './helpers';

export const useLegalClientHeadSaveAddresses = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientHeadSaveAddressesMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientHeadSaveAddresses
      ? parseLegalClientHeadEntity(data.legalClientHeadSaveAddresses)
      : undefined,
    loading,
    error,
    saveAddresses: useCallback(
      async (id: string, headId: string, params: AddressesWithFilesParam) => {
        const res = await handle({
          variables: {
            id,
            headId,
            input: {
              placeOfBirth: isGlobalProject() ? params.placeOfBirth : undefined,
              registrationAddress: isFinanceProject()
                ? params.registrationAddress
                : undefined,
              residentialAddress: params.residentialAddress,
            },
          },
        });
        return res?.data?.legalClientHeadSaveAddresses
          ? parseLegalClientHeadEntity(res.data.legalClientHeadSaveAddresses)
          : undefined;
      },
      [handle]
    ),
  };
};
